// Data Presensi Mahasiswa

export const dataPresensi = [
    // Presensi untuk jadwal_id: 1 (Metodologi Penelitian)
    {
        presensi_id: 1,
        jadwal_id: 1,
        pertemuan: 1,
        tanggal: "2024-09-02",
        materi: "Pengantar Metodologi Penelitian",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 2,
        jadwal_id: 1,
        pertemuan: 2,
        tanggal: "2024-09-09",
        materi: "Jenis-jenis Penelitian",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "I", keterangan: "Sakit" }
        ]
    },
    {
        presensi_id: 3,
        jadwal_id: 1,
        pertemuan: 3,
        tanggal: "2024-09-16",
        materi: "Perumusan Masalah",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 4,
        jadwal_id: 1,
        pertemuan: 4,
        tanggal: "2024-09-23",
        materi: "Studi Literatur",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "A", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 5,
        jadwal_id: 1,
        pertemuan: 5,
        tanggal: "2024-09-30",
        materi: "Metodologi Kuantitatif",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 6,
        jadwal_id: 1,
        pertemuan: 6,
        tanggal: "2024-10-07",
        materi: "Metodologi Kualitatif",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 7,
        jadwal_id: 1,
        pertemuan: 7,
        tanggal: "2024-10-14",
        materi: "Review & UTS",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" },
            { nim: "20201003", nama: "Cahyo Nugroho", status: "H", keterangan: "" }
        ]
    },

    // Presensi untuk jadwal_id: 2 (Deep Learning)
    {
        presensi_id: 8,
        jadwal_id: 2,
        pertemuan: 1,
        tanggal: "2024-09-03",
        materi: "Introduction to Deep Learning",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 9,
        jadwal_id: 2,
        pertemuan: 2,
        tanggal: "2024-09-10",
        materi: "Neural Networks Fundamentals",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "H", keterangan: "" }
        ]
    },
    {
        presensi_id: 10,
        jadwal_id: 2,
        pertemuan: 3,
        tanggal: "2024-09-17",
        materi: "Convolutional Neural Networks",
        data_mhs: [
            { nim: "20201001", nama: "Andi Pratama", status: "H", keterangan: "" },
            { nim: "20201002", nama: "Bella Safitri", status: "I", keterangan: "Izin kegiatan kampus" }
        ]
    }
];

// Rekap presensi per mahasiswa
export const rekapPresensiMahasiswa = [
    {
        nim: "20201001",
        nama: "Andi Pratama",
        prodi: "Teknik Informatika",
        semester: 7,
        rekap: [
            { jadwal_id: 1, nama_mk: "Metodologi Penelitian", total_pertemuan: 7, hadir: 7, izin: 0, alpha: 0, persentase: 100 },
            { jadwal_id: 2, nama_mk: "Deep Learning", total_pertemuan: 3, hadir: 3, izin: 0, alpha: 0, persentase: 100 },
            { jadwal_id: 3, nama_mk: "Blockchain", total_pertemuan: 5, hadir: 5, izin: 0, alpha: 0, persentase: 100 },
            { jadwal_id: 4, nama_mk: "Cyber Security", total_pertemuan: 5, hadir: 4, izin: 1, alpha: 0, persentase: 80 }
        ]
    },
    {
        nim: "20201002",
        nama: "Bella Safitri",
        prodi: "Teknik Informatika",
        semester: 7,
        rekap: [
            { jadwal_id: 1, nama_mk: "Metodologi Penelitian", total_pertemuan: 7, hadir: 6, izin: 0, alpha: 1, persentase: 85.71 },
            { jadwal_id: 2, nama_mk: "Deep Learning", total_pertemuan: 3, hadir: 2, izin: 1, alpha: 0, persentase: 66.67 }
        ]
    },
    {
        nim: "20201003",
        nama: "Cahyo Nugroho",
        prodi: "Teknik Informatika",
        semester: 7,
        rekap: [
            { jadwal_id: 1, nama_mk: "Metodologi Penelitian", total_pertemuan: 7, hadir: 6, izin: 1, alpha: 0, persentase: 85.71 }
        ]
    }
];

// Get presensi by jadwal
export const getPresensiByJadwal = (jadwal_id) => {
    return dataPresensi.filter(p => p.jadwal_id === jadwal_id);
};

// Get presensi by mahasiswa
export const getPresensiByMahasiswa = (nim) => {
    const result = [];
    dataPresensi.forEach(p => {
        const mhs = p.data_mhs.find(m => m.nim === nim);
        if (mhs) {
            result.push({
                ...p,
                status: mhs.status,
                keterangan: mhs.keterangan
            });
        }
    });
    return result;
};

export default { dataPresensi, rekapPresensiMahasiswa };
